module.exports = "/_next/static/images/AiAdoptionGraph@2x-70d4c1e716e560c4b906ac57dad35b13.webp";